import ProductRepository from 'client-sdk/src/Repository/product-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_PRODUCTS_FAILED,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS,
  GET_PRODUCT_FAILED,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT,
  GET_VARIANT_FAILED,
  GET_VARIANT_SUCCESS,
  GET_VARIANT,
  UPDATE_PRODUCTS_FAILED,
  UPDATE_PRODUCTS_SUCCESS,
  UPDATE_PRODUCTS,
  CREATE_PRODUCTS_FAILED,
  CREATE_PRODUCTS_SUCCESS,
  CREATE_PRODUCTS,
  GET_PRODUCTS_INVONTORY,
  GET_PRODUCTS_INVONTORY_SUCCESS,
  GET_PRODUCTS_INVONTORY_FAILED,
  GET_PRODUCT_VARIANTS,
  GET_PRODUCT_VARIANTS_SUCCESS,
  GET_PRODUCT_VARIANTS_FAILED,
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_FAILED,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILED,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS,
  GET_PARTNER_CATEGORIES_SUCCESS,
  GET_PARTNER_CATEGORIES_FAILED,
  GET_PARTNER_CATEGORIES,
  GET_VITRIN_PRODUCTS,
  GET_VITRIN_PRODUCTS_SUCCESS,
  GET_VITRIN_PRODUCTS_FAILED,
  DELETE_VARIANT_SUCCESS,
  DELETE_VARIANT_FAILED,
  DELETE_VARIANT,
} from './constants';

import {
  GetAllProductsRequestBuilder,
  GetProductsCountRequestBuilder,
  UpdateProductRequestBuilder,
  CreateProductRequestBuilder,
  GetProductsInventoryRequestBuilder,
  GetProductsVariantRequestBuilder,
  GetVariantsRequestBuilder,
  GetCategoriesRequestBuilder,
  GetProductsVariantInventoryItemsRequestBuilder,
  GetPartnerCategoriesBuilder,
} from 'client-sdk/src/products/products';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication.tsx';

const token = localStorage.getItem('token') || '';

export function* getProducts(actions: any): unknown {
  try {
    const {response, count} = yield ProductRepository.getProducts(actions);
    yield put({
      type: GET_PRODUCTS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getVitrinProducts(actions: any): unknown {
  try {
    const response = yield ProductRepository.getVitrinSelectedProduct(actions);
    const count = yield ProductRepository.getVitrinSelectedProductsCount(
      actions
    );
    yield put({
      type: GET_VITRIN_PRODUCTS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_VITRIN_PRODUCTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getProduct(actions: any): any {
  try {
    const response = yield ProductRepository.getProduct(actions);
    yield put({
      type: GET_PRODUCT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getVariant(actions: any): any {
  const {id} = actions.payload;
  try {
    const {response} = yield ProductRepository.getVariant(actions);
    yield put({
      type: GET_VARIANT_SUCCESS,
      data: id ? response.data : response.data.content[0],
    });
  } catch (error) {
    yield put({
      type: GET_VARIANT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCategories(actions: any): unknown {
  try {
    const response = yield ProductRepository.getCategories(actions);
    yield put({
      type: GET_CATEGORIES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CATEGORIES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getPartnerCategories(actions: any): unknown {
  try {
    const response = yield ProductRepository.getPartnerCategories(actions);

    yield put({
      type: GET_PARTNER_CATEGORIES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNER_CATEGORIES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllProducts(actions: any): unknown {
  try {
    const response = yield ProductRepository.getAllProducts(actions);
    yield put({
      type: GET_ALL_PRODUCTS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_PRODUCTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateProduct(actions: any): unknown {
  const {pagination, id, callback} = actions.payload;
  try {
    yield ProductRepository.updateProduct(actions);
    yield put({
      type: UPDATE_PRODUCTS_SUCCESS,
    });
    handleNotfication('کالای مورد نظر با موفقیت ویرایش شد', 'success');
    if (!callback) {
      yield put({
        type: GET_PRODUCTS,
        payload: {
          ...pagination,
          partnerId: {equals: id || null},
        },
      });
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({
      type: UPDATE_PRODUCTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createProduct(actions: any): unknown {
  const {pagination, id, callback} = actions.payload;
  try {
    yield ProductRepository.createProduct(actions);
    yield put({
      type: CREATE_PRODUCTS_SUCCESS,
    });
    yield put({
      type: GET_PRODUCTS,
      payload: {...pagination, partnerId: {equals: id}},
    });
    callback();

    handleNotfication('محصول با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_PRODUCTS_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن محصول با خطا مواجه شد', 'error');
    handleError(error.response);
  }
}

export function* getProductsInventory(actions: any): unknown {
  try {
    const response = yield ProductRepository.getProductsInventory(actions);
    yield put({
      type: GET_PRODUCTS_INVONTORY_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCTS_INVONTORY_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getProductVariants(actions: any): unknown {
  try {
    const response = yield ProductRepository.getProductVariants(actions);
    yield put({
      type: GET_PRODUCT_VARIANTS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCT_VARIANTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getProductVariantInventoryItems(actions: any): any {
  try {
    const response = yield ProductRepository.getProductVariantInventoryItems(
      actions
    );
    yield put({
      type: GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* deleteVariant(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    yield ProductRepository.deleteVariants(actions);
    yield put({
      type: DELETE_VARIANT_SUCCESS,
    });
    callback && callback();
    handleNotfication('تنوع مورد نظر شما با موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: DELETE_VARIANT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* productSaga() {
  yield takeLatest(GET_PRODUCTS, getProducts);
  yield takeLatest(GET_VITRIN_PRODUCTS, getVitrinProducts);
  yield takeLatest(GET_CATEGORIES, getCategories);
  yield takeLatest(GET_PRODUCT, getProduct);
  yield takeLatest(GET_VARIANT, getVariant);
  yield takeLatest(DELETE_VARIANT, deleteVariant);
  yield takeLatest(GET_ALL_PRODUCTS, getAllProducts);
  yield takeLatest(UPDATE_PRODUCTS, updateProduct);
  yield takeLatest(CREATE_PRODUCTS, createProduct);
  yield takeLatest(GET_PRODUCTS_INVONTORY, getProductsInventory);
  yield takeLatest(GET_PRODUCT_VARIANTS, getProductVariants);
  yield takeLatest(
    GET_PRODUCT_VARIANT_INVENTORY_ITEMS,
    getProductVariantInventoryItems
  );
  yield takeLatest(GET_PARTNER_CATEGORIES, getPartnerCategories);
}
